import React, { useState, useEffect } from 'react';
import ClientCalling from '../api/ClientCalling';
import { useNavigate, useLocation } from 'react-router-dom';

const Gateway = () => {
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const handleRedirect = async () => {
            // Check if mobile
            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            // const isMobile = true;

            // Check if query param u=dfsdf
            const searchParams = new URLSearchParams(location.search);
            const uParam = searchParams.get('u');

            if (isMobile && uParam) {
                try {
                    setLoader(true);
                    const resp = await ClientCalling.getBlogRendom();

                    if (resp?.status && resp?.data?.main_title) {
                        // Convert spaces to hyphens for URL
                        const slug = resp.data.main_title.replace(/\s+/g, '-').toLowerCase();
                        navigate(`/blog/info/${slug}?u=asdfgh`);
                    } else {
                        navigate('/blog'); // fallback
                    }
                } catch (err) {
                    console.error('gateway error:', err);
                    navigate('/blog');
                } finally {
                    setLoader(false);
                }
            } else {
                // For all other cases, just redirect to /blog
                navigate('/blog');
            }
        };

        handleRedirect();
    }, [location.search, navigate]);

    return <div className="min-h-screen dm-sans client-home-bg" />;
};

export default Gateway;
